module.exports = __webpack_public_path__ + "img/icon_4_40.a7d2c9a7.png";